/**
 * PriorityBadge Component
 *
 * Displays priority levels with appropriate colors.
 * Colors: critical=red, high=orange, medium=yellow, low=gray
 */

type Priority = 'critical' | 'high' | 'medium' | 'low';

interface PriorityBadgeProps {
  priority: Priority;
  className?: string;
}

const priorityConfig: Record<Priority, { label: string; className: string }> = {
  critical: {
    label: 'Critical',
    className: 'bg-red-100 text-red-700 border-red-200',
  },
  high: {
    label: 'High',
    className: 'bg-orange-100 text-orange-700 border-orange-200',
  },
  medium: {
    label: 'Medium',
    className: 'bg-yellow-100 text-yellow-700 border-yellow-200',
  },
  low: {
    label: 'Low',
    className: 'bg-gray-100 text-gray-600 border-gray-200',
  },
};

export function PriorityBadge({ priority, className = '' }: PriorityBadgeProps): JSX.Element {
  const config = priorityConfig[priority] || priorityConfig.low;

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 text-xs font-medium rounded border ${config.className} ${className}`}
    >
      {config.label}
    </span>
  );
}

export default PriorityBadge;
